import React from 'react';

import { twentySixteen } from '../components/images';
import ImageGallery from '../components/image-gallery';

const TwentySixteen = () => <ImageGallery images={twentySixteen} year="2016" />;

export default TwentySixteen;
